import { getProductName } from 'src/features/dpo/helpers/tealium-service-helpers';
import { CatalogueItem } from './../../common/types/catalogue';

export enum PageName {
  CHOOSE_SOLUTION = 'choose solution',
  TENDER_TYPE = 'tender type',
  PERSONAL_DETAILS = 'personal details',
  ORDER_SUMMARY = 'order summary',
  ORDER_COMPLETE = 'order complete',
  PAYMENT_FAILURE = 'payment failure',
  USER_UNDER_18_MODAL = 'user under 18 modal',
  SUBMIT_APP_CONFIRMATION = 'submit application confirmation',
  REDUCE_QUANTITY_CONFIRM = 'reduce quantity confirmation',
  PAYMENT_FAILED = 'payment failed',
  DELIVERY_ADDRESS = 'delivery address',
  ALLOCATE_DEVICE = 'allocate device to address',
  TAP_ON_PHONE = 'tap on phone',
  TAP_ON_PHONE_GET_STARTED = 'tap on phone: lets get started',
  ORDER_SUMMARY_MODAL = 'order summary: reserve funds',
  SUBMIT_APP_MODAL = 'order summary: submit application',
}

export enum LinkName {
  CART_VIEW = 'cart view',
  CART_ADD = 'cart add',
  CART_REMOVE = 'cart remove',
  SELECT_DELIVERY_METHOD = 'select delivery method',
  SHOW_BUSINESS_ADDRESS = 'show business address',
  NEXT = 'next',
  SUBMIT = 'submit',
  REDUCE_QUANTITY_CONFIRM = 'reduce quantity confirm',
  PAYMENT_FAILED_RETRY = 'payment failed retry',
  CHECKOUT = 'checkout',
  PROCEED_TO_CHECKOUT = 'proceed to checkout',
  DONE = 'done',
  ADD_PRODUCT = 'add product',
  REMOVE_PRODUCT = 'remove Product',
  TAP_ON_PHONE_MODAL_CLOSE = 'tap on phone: close',
  TAP_ON_PHONE_GET_IT = 'tap on phone: show more: close: get it here',
  HOW_WILL_CUSTOMER_PAY = 'how will the customer be paying',
  PAY_NOW = 'pay now',
  DOWNLOAD = 'download',
  PRINT = 'print',
  ADD_DELIVERY_ADDRESS = 'add delivery address',
  EDIT_DELIVERY_ADDRESS = 'edit delivery address',
  REMOVE_DELIVERY_ADDRESS = 'remove delivery address',
  ALLOCATE_DEVICE_TO_ADDRESS = 'allocate device to address',
  CLOSE_APPLICATION = 'close application',
  CLOSE_MODAL = 'close modal',
  PERSONAL_DETAILS = 'personal details',
  ORDER_SUMMARY_MODAL = 'order summary: reserve funds: ',
  SUBMIT_APP_MODAL = 'order summary: submit application',
}

export enum EventName {
  PAGE_VIEW = 'page_view',
  UI_INTERACTION = 'ui_interaction',
  JOURNEY_START = 'journey_start',
  JOURNEY_END = 'journey_end',
  JOURNEY_STEP = 'journey_step',
  EVENT_ERROR = 'event_error',
  SUPPORT_ISSUE_RAISED = 'support_issue_raised',
  FORM_START = 'form_start',
  FORM_END = 'form_end',
  CART_VIEW = 'cart_view',
  CART_ADD = 'cart_add',
  CART_REMOVE = 'cart_remove',
  CHECKOUT = 'scCheckout',
  ADD = 'scAdd',
  REMOVE = 'scRemove',
  FORM_ERROR = 'form_error',
  FORM_STEP = 'form_step',
  PAGE_ERROR = 'page_error',
}

export enum JourneyType {
  SELF_SERVICE = 'self service',
  ONBOARDING = 'onboarding',
}

export enum HelpButtonAction {
  CLICK = 'vodapay: self service: help',
  CALL = 'vodapay: self service: call support number',
  EMAIL = 'vodapay: self service: email support',
}

export enum ActionType {
  CANCEL = 'cancel',
  RESERVE = 'reserve fund',
  CLOSE = 'close',
  CONFIRM = 'submit',
}

export type ProductList = {
  name: string[];
  quantity: string[];
  price: string[];
  transactionTotal: number;
};

export const getProductListItems = (productList: CatalogueItem[], isPaymentSuccess: boolean) => {
  let products: ProductList = { name: [], quantity: [], price: [], transactionTotal: 0 };

  productList.forEach((product) => {
    const device = product.device;
    const price = product.price.price ? product.price.price / 100 : 0;
    if (product.device.quantity !== undefined) {
      products.name.push(getProductName(device.title.toString()));
      products.quantity.push(device.quantity.toString());
      products.price.push(price.toString());
      products.transactionTotal =
        price !== 0
          ? products.transactionTotal + price * device.quantity
          : products.transactionTotal;
    }
  });

  const productListAnalytics = {
    product_name: products.name,
    product_quantity: products.quantity,
    product_price: products.price,
  };

  if (isPaymentSuccess) {
    return { ...productListAnalytics, transaction_total: products.transactionTotal.toString() };
  }

  return productListAnalytics;
};
